module.exports = __webpack_public_path__ + "static/tecnologias-29a8b1fe96a3e51f75ff1be1c06aa54d.png";